import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function LevelIncome() {

  const token = localStorage.getItem("adminToken");

  const [records, setRecords] = useState([]);

  useEffect(() => {

    loadLevelIncome();

  }, []);

  async function loadLevelIncome() {

    try {

      const res = await fetch("/api/admin/level-income", {

        headers: {
          Authorization: "Bearer " + token
        }

      });

      const json = await res.json();

      if (json.success) {

        setRecords(json.records || []);

      }

    } catch (err) {

      console.log(err);

    }

  }

  return (

    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: "#f3f4f6"
      }}
    >

      <Sidebar />

      <div
        style={{
          flex: 1
        }}
      >

        <Header />

        <div
          style={{
            padding: 25
          }}
        >

          <h2>30 Level Income History</h2>

          <table
            width="100%"
            cellPadding="10"
            style={{
              background: "#fff",
              borderCollapse: "collapse"
            }}
          >

            <thead>

              <tr
                style={{
                  background: "#2563eb",
                  color: "#fff"
                }}
              >

                <th>Receiver</th>

                <th>From User</th>

                <th>Level</th>

                <th>Amount</th>

                <th>Currency</th>

                <th>Date</th>

              </tr>

            </thead>

            <tbody>

              {

                records.length === 0 ? (

                  <tr>

                    <td
                      colSpan="6"
                      style={{
                        textAlign: "center",
                        padding: 20
                      }}
                    >

                      No Level Income Found

                    </td>

                  </tr>

                ) : (

                  records.map((item) => (

                    <tr key={item._id}>

                      <td>{item.userId}</td>

                      <td>{item.fromUserId}</td>

                      <td>{item.level}</td>

                      <td>

                        {Number(
                          item.amount || 0
                        ).toFixed(4)}

                      </td>

                      <td>

                        {item.currency || "USDT"}

                      </td>

                      <td>

                        {new Date(
                          item.createdAt
                        ).toLocaleString()}

                      </td>

                    </tr>

                  ))

                )

              }

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );

}
